import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={15}
      height={16}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M13.492 1H1.508C1.228 1 1 1.245 1 1.547c0 1.523.606 2.977 1.663 3.989l2.224 2.128c.386.37.607.9.607 1.456v5.333c0 .435.452.697.79.454l2.995-2.15a.56.56 0 00.226-.455V9.12c0-.556.222-1.087.607-1.456l2.224-2.128C13.393 4.524 14 3.07 14 1.546c0-.301-.227-.546-.507-.546zm-1.83 3.718L9.437 6.847a3.15 3.15 0 00-.948 2.272v2.89L6.51 13.43V9.12a3.15 3.15 0 00-.948-2.273L3.338 4.718a4.358 4.358 0 01-1.29-2.624h10.903a4.357 4.357 0 01-1.29 2.624z"
        fill="#616161"
        stroke="#616161"
        strokeWidth={0.3}
      />
    </Svg>
  );
}

export default SvgComponent;
